var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5H7V5.5H17V19.5ZM17 1.5H7C5.89 1.5 5 2.39 5 3.5V21.5C5 22.0304 5.21071 22.5391 5.58579 22.9142C5.96086 23.2893 6.46957 23.5 7 23.5H17C17.5304 23.5 18.0391 23.2893 18.4142 22.9142C18.7893 22.5391 19 22.0304 19 21.5V3.5C19 2.39 18.1 1.5 17 1.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone .b17cda892cf6864f94329402b6bc0fb6.svg";
export { ForwardRef as ReactComponent };